//
// Module for Benefit Estimate DROP transactions grid
//
rs.module("ui/controls/content/benefitestimatetabs/droptransactionsgrid",

    [ /* dependencies */],

    function () {

        function initialize(jsSelectors, backendUrls) {

            var modalContainer = $.js(jsSelectors.modalContainer);
            var modalLoadingSpinner = modalContainer.js(jsSelectors.modalLoadingSpinner);
            var interestDetailsModal = modalContainer.js(jsSelectors.interestDetailsModal);
            var interestDetailsContent = modalContainer.js(jsSelectors.interestDetailsContent);
            var dropTransactionsGrid = $.js(jsSelectors.dropTransactionsGrid);

            // Listen for view modal click
            dropTransactionsGrid.onjs('click', jsSelectors.viewModalLink, function () {
                var dropTransactionKey = $(this).data("routeDroptransactionkey");

                // show loading spinner
                modalLoadingSpinner.show();

                $.get(
                    backendUrls.loadInterestDetailsAsync,
                    {
                        dropTransactionKey: dropTransactionKey
                    }

                ).done(function (results) {
                    interestDetailsModal.modal('show');
                    interestDetailsContent.html(results);
                }
                ).always(function () {

                    // hide loading spinner
                    modalLoadingSpinner.hide();
                });
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);